export default __webpack_public_path__ + "static/media/harpa-white.9d4094e3.png";